import {
  createStyles,
  makeStyles,
  Theme,
} from '@material-ui/core/styles';

const useStyles = makeStyles<Theme>((theme) =>
  createStyles({
    container: {
      width: '648px',
      marginBottom: '10px',
    },
    title: {
      fontSize: '16px',
      textAlign: 'left',
      color: '#0047BA',
    },
    paragraph: {
      fontSize: '14px',
      textAlign: 'left',
      color: '#646464',
    },
    lists: {
      marginLeft: '100px',
    },
  })
);

export default useStyles;
